import React from "react";
import { Link } from "react-router-dom";
import { LAB_PRODUCCION_ESTADOS_DRC } from "../../../../../../../utility/constants";

const editarIcon = require("assets/img/icons/editar.png");
const verIcon = require("assets/img/icons/ver.png");
const repetirIcon = require("assets/img/icons/undo_active.png");


export const getActionBtn = (estadoSolicitudes, item, repeticion) => {
    const itemId = item.id;
    let actionBtn = null;

    if (estadoSolicitudes === "PENDIENTES") {
        actionBtn = (
            <Link to={`analizar_drc/${itemId}`}>
                <img
                    src={editarIcon}
                    alt="Analizar"
                    className="action_img"
                    title="Analizar"
                />
            </Link>
        );
    } else if (
        estadoSolicitudes === LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_VALIDAR_DRC
    ) {
        actionBtn = (
            <Link to={`validar_drc/${itemId}`}>
                <img
                    src={editarIcon}
                    alt="Validar"
                    className="action_img"
                    title="Validar"
                />
            </Link>
        );
    } else if (estadoSolicitudes === "HISTORIAL") {
        actionBtn = (
            <React.Fragment>
                <Link to={`detalle/${itemId}`}>
                    <img
                        src={verIcon}
                        alt="Ver detalle"
                        className="action_img"
                        title="Ver detalle"
                    />
                </Link>
                {item.estado === LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO && (
                    <img
                        src={repetirIcon}
                        alt="Repetir análisis"
                        className="action_img"
                        title="Repetir análisis"
                        onClick={() => repeticion.IniciarRepeticion(item)}
                    />
                )}
            </React.Fragment>
        );
    }

    return actionBtn;
};
